import './TagForm.scss';

const TagForm = ({ children, onSubmit }) => {
  return <form className="TagForm" onSubmit={onSubmit}>{children}</form>;
};

export default TagForm;
